import Product from "./Product";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

function ProductList(props) {
	return (
		<Container fluid>
			<Row>
				{props.data.map((eachData) => (
					<Col
						xs={6}
						sm={4}
						md={3}
						lg={3}
						xl={2}
						xxl={2}
						className="mb-3"
						key={eachData.id}
					>
						<Product {...eachData} />
					</Col>
				))}
			</Row>
		</Container>
	);
}
export default ProductList;
